import { render } from "./MainLoader.vue?vue&type=template&id=75e3c292"
import script from "./MainLoader.vue?vue&type=script&lang=js"
export * from "./MainLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__